import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {inspect} from '../../../schema/inspect'
import {InspectModel} from '../../../model'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {TabLavanderiaModel} from '../../../../../models'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {createInspect, deleteInspect, updateInspect} from '../../../services'
import {renderPanelContent} from '../components'
import {ShowSnackBar, getDataModified} from '../../../../../util/functions'
import {funcDelete} from '../../../util/function'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
  ERROR_MESSAGE_SYSTEM,
} from '../../../../../util/Constants'
const InspectPageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [loading, setLoading] = useState(false)
  const methods = useForm<InspectModel>({
    resolver: yupResolver(inspect),
  })
  const {reset} = methods
  const handleDelete = async () => {
    await funcDelete(
      deleteInspect,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: InspectModel) => {
    try {
      setLoading(true)
      data = getDataModified(data)
      data.cumpleEstandar = data.cumpleEstandar === 'NO' ? false : true
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createInspect(data)
        : await updateInspect({...data, id: currentTabItem.idToEdit})
      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabLavanderiaModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-inspect',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-inspect'
          textComponentGo='form-inspect'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-lavanderia-header-${currentTabItem.id}`}
              id={`panel-lavanderia-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-lavanderia-detail-${currentTabItem.id}`}
                    id={`panel-lavanderia-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default InspectPageWrapper
